var React = require('react');

function IconAngleDownCircleO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M958.5 513.2c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.3 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z","key":0}),React.createElement("path",{"d":"M703 448.4c1.6-1.6 1.6-4.1 0-5.7l-26-26c-1.6-1.6-4.1-1.6-5.7 0l-158 158-157.5-157.6c-1.6-1.6-4.1-1.6-5.7 0L324 443.2c-1.6 1.6-1.6 4.1 0 5.7l186.7 186.7c1.6 1.6 4.1 1.6 5.7 0","key":1})]);
}

IconAngleDownCircleO.displayName = "IconAngleDownCircleO";

IconAngleDownCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconAngleDownCircleO;

IconAngleDownCircleO.default = IconAngleDownCircleO;
